import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import OurTakeHighlight from '@nerdwallet/react-our-take-highlight';
import { KetoCompareCardCheckBox } from '@nerdwallet/compare-credit-cards-bar';
import { LTOBanner, LTODetails } from '@nerdwallet/bain-components';
import styles from "./keto-product-card.module.css";
export var BaseKetoProductCard = function BaseKetoProductCard(_ref) {
  var _ref2;
  var accordionNode = _ref.accordionNode,
    _ref$addToFavoritesNo = _ref.addToFavoritesNode,
    addToFavoritesNode = _ref$addToFavoritesNo === void 0 ? null : _ref$addToFavoritesNo,
    className = _ref.className,
    driversNode = _ref.driversNode,
    forceMobile = _ref.forceMobile,
    headerNode = _ref.headerNode,
    imageAndRatingNode = _ref.imageAndRatingNode,
    alternateCta = _ref.alternateCta,
    isInCompare = _ref.isInCompare,
    isPreheaderBadge = _ref.isPreheaderBadge,
    ourTakeHighlight = _ref.ourTakeHighlight,
    sectionName = _ref.sectionName,
    sideBySideCompareOptions = _ref.sideBySideCompareOptions,
    marketplaceEntity = _ref.marketplaceEntity,
    checkboxLabel = _ref.checkboxLabel,
    handleCompare = _ref.handleCompare,
    isSelectedToCompare = _ref.isSelectedToCompare,
    _ref$isNwPlusVariant = _ref.isNwPlusVariant,
    isNwPlusVariant = _ref$isNwPlusVariant === void 0 ? false : _ref$isNwPlusVariant,
    isLimitedTimeOffer = _ref.isLimitedTimeOffer,
    isSoFiDynamicPlacement = _ref.isSoFiDynamicPlacement;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([className, styles.ketoProductCardContainer, (_ref2 = {}, _defineProperty(_ref2, styles.ketoProductCardTopMargin, !isPreheaderBadge), _defineProperty(_ref2, styles.ketoProductCardContainerCheckBoxSelected, isInCompare), _defineProperty(_ref2, styles.forceMobile, forceMobile), _defineProperty(_ref2, styles.ketoProductCardSBSCTopMargin, sideBySideCompareOptions), _defineProperty(_ref2, styles.nwPlusVariant, isNwPlusVariant), _defineProperty(_ref2, styles.ketoProductCardLTOTopMargin, isLimitedTimeOffer || isSoFiDynamicPlacement), _defineProperty(_ref2, styles.ketoProductCardBlueBorder, isSoFiDynamicPlacement), _ref2)])
  }, sideBySideCompareOptions && !addToFavoritesNode && /*#__PURE__*/React.createElement("div", {
    className: classNames([className, styles.ketoSbscHeader, !isPreheaderBadge && styles.ketoSbscHeaderBottomMargin, _defineProperty({}, styles.sbscVariantPosition, sideBySideCompareOptions.variantPosition)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.compareBtnDesktop, isPreheaderBadge && styles.compareTopMargin])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.compareCheckbox
  }, /*#__PURE__*/React.createElement(KetoCompareCardCheckBox, {
    card: {
      id: marketplaceEntity === null || marketplaceEntity === void 0 ? void 0 : marketplaceEntity.legacyId,
      offerId: marketplaceEntity === null || marketplaceEntity === void 0 ? void 0 : marketplaceEntity.id
    },
    analytics: {
      enabled: true
    },
    showCheckboxLabel: true,
    checkboxLabel: checkboxLabel,
    handleCompare: handleCompare,
    isSelectedToCompare: isSelectedToCompare
  })))), isLimitedTimeOffer && !isSoFiDynamicPlacement && /*#__PURE__*/React.createElement("div", {
    className: styles.ketoLtoHeaderBottomMargin
  }, /*#__PURE__*/React.createElement(LTOBanner, {
    version: "ribbon"
  })), isSoFiDynamicPlacement && /*#__PURE__*/React.createElement("div", {
    className: styles.ketoLtoAdBugHeaderBottomMargin
  }, /*#__PURE__*/React.createElement(LTOBanner, {
    version: "adbug"
  })), addToFavoritesNode && /*#__PURE__*/React.createElement("div", {
    className: styles.favoritesHeader
  }, addToFavoritesNode), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoProductCardHeader
  }, headerNode), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoBody
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ketoImageAndRatingContainer
  }, imageAndRatingNode), ourTakeHighlight && /*#__PURE__*/React.createElement("div", {
    className: styles.ketoOurTakeWrapper
  }, /*#__PURE__*/React.createElement(OurTakeHighlight, {
    bannerType: ourTakeHighlight.type,
    content: ourTakeHighlight.content,
    analytics: {
      entityName: 'cc_product_our_take_flag',
      sectionName: sectionName
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoProductCardDriversContent
  }, driversNode), alternateCta && /*#__PURE__*/React.createElement("div", {
    className: styles.alternateCta
  }, alternateCta)), /*#__PURE__*/React.createElement("div", {
    className: styles.ketoProductCardAccordion
  }, accordionNode), isLimitedTimeOffer && !isSoFiDynamicPlacement && /*#__PURE__*/React.createElement(LTODetails, null));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');
  BaseKetoProductCard.propTypes = {
    accordionNode: PropTypes.node,
    alternateCta: PropTypes.node,
    className: PropTypes.string,
    driversNode: PropTypes.node,
    forceMobile: PropTypes.bool,
    headerNode: PropTypes.node,
    imageAndRatingNode: PropTypes.node,
    isInCompare: PropTypes.bool,
    isNwPlusVariant: PropTypes.bool,
    isPreheaderBadge: PropTypes.bool,
    sectionName: PropTypes.string
  };
}
export default BaseKetoProductCard;